import { gql } from '@urql/core'

export const UPDATE_BIO = gql`
  mutation UpdateBio($bio: String!) {
    updateBio(bio: $bio) {
      bio
    }
  }
`
